export { default as Banner } from "./Banner";
export { default as SectionVertical } from "./Section/ShopVertical";
export { default as SectionHorizontal } from "./Section/ShopHorizontal";
export { default as ShopVerticalSection } from "./Section/ShopVerticalSection";
export { default as Category } from "./Category";
export { default as SectionExperienceOffer } from "./Section/ExperienceOffer";
export { default as SectionPackage } from "./Section/Package";
export { default as SectionSlotDiscount } from "./Section/SlotDiscount";
